export default "__VITE_ASSET__DjEEzbGn__"